import { createStyles } from "@material-ui/core";

export const styles = createStyles({

  iconButtonWrapper: {
    alignItems: "center",
    position: "absolute",
    bottom: 0,
    right: 0
  }

});